export enum Role {
  AGENT = 'AGENT',
  SUPERVISOR = 'SUPERVISOR',
  AGENT_AND_SUPERVISOR = 'AGENT_AND_SUPERVISOR',
}
